export function MobileLoadingCards() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse rounded-2xl border border-slate-800 bg-slate-950/80 p-4"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl bg-slate-800" />

              <div className="space-y-2">
                <div className="h-3.5 w-24 rounded bg-slate-800" />
                <div className="h-3 w-16 rounded bg-slate-800" />
              </div>
            </div>

            <div className="h-6 w-16 rounded-full bg-slate-800" />
          </div>

          <div className="mt-4 h-16 rounded-xl bg-slate-900" />

          <div className="mt-3 grid grid-cols-2 gap-3">
            <div className="h-16 rounded-xl bg-slate-900" />
            <div className="h-16 rounded-xl bg-slate-900" />
          </div>

          <div className="mt-3 grid grid-cols-2 gap-3">
            <div className="h-16 rounded-xl bg-slate-900" />
            <div className="h-16 rounded-xl bg-slate-900" />
            <div className="h-16 rounded-xl bg-slate-900" />
            <div className="h-16 rounded-xl bg-slate-900" />
          </div>

          <div className="mt-4 flex gap-2 border-t border-slate-800 pt-4">
            <div className="h-10 flex-1 rounded-md bg-slate-800" />
            <div className="h-10 flex-1 rounded-md bg-slate-800" />
            <div className="h-10 w-10 rounded-md bg-slate-800" />
          </div>
        </div>
      ))}
    </div>
  );
}
